export default __webpack_public_path__ + "static/media/redaction-contenu.1398ebde.svg";